import React from 'react';
import PropTypes from 'prop-types';

// StyleGuide = elements/global/loading-icon

const LoadingIcon = ({
  children = 'Loading...',
  size = 'small',
  hideIcon = false,
  hideLabel = false,
  overlay = false,
  className = '',
  backgroundOpacity = 0.5,
}) => {
  const style = {};

  let computedClassName = className;
  if (overlay) {
    computedClassName += ' loading-icon-overlay';
    style.backgroundColor = `rgba(255, 255, 255, ${backgroundOpacity})`;
  }

  if (size === 'large') {
    return (
      <div className={`LoadingIcon loading-icon-large ${computedClassName}`} style={style}>
        <img className="loading-icon-image" alt="Loading..." src="/loader.gif" />
      </div>
    );
  }

  return (
    <div className={`LoadingIcon loading-icon-${size} ${computedClassName}`} style={style}>
      {!hideIcon && (
        <div className="loading-icon-icon" />
      )}
      {!hideLabel && (
        <div role="alert" aria-live="assertive" className="loading-icon-label">{children}</div>
      )}
    </div>
  );
};

LoadingIcon.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  hideIcon: PropTypes.bool,
  hideLabel: PropTypes.bool,
  overlay: PropTypes.bool,
  className: PropTypes.string,
  backgroundOpacity: PropTypes.number,
};

export default LoadingIcon;
